<template>
  <div class="home" :style="{'transform': transform, 'top': top, 'left':left}">
    <top-bar />
    <home-head />
    <div class="home-main">
      <div class="home-left">
        <left-top />
        <left-center />
        <left-bottom />
      </div>
      <div class="home-center">
        <center-top/>
        <center-bottom />
      </div>
      <div class="home-bottom">
        <right-top />
        <right-center />
        <right-bottom />
      </div>
    </div>
    <el-dialog
      title="产品交易额/销量TOP排名"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class='commonDialog'
      :visible.sync="modelShow"
    >
      <div class='mask'></div>
      <div class='ux-panel'>
        <div class='title'>{{title}}</div>
        <div class="head-list">
          <div v-for="(item, index) in headList" :key="index">
            {{item.name}}{{item.value | formatNumber}}{{item.unit}}
          </div>
        </div>
        <div class='ux-tabs tabs'>
          <div class="ux-filter-records filter-records">
            <div class='content-list'>
              <el-table
                class="table ux-dark-el-table"
                :data="tableData"
                max-height="550"
                empty-text="暂无数据"
                element-loading-spinner="el-icon-loading">
                  <el-table-column v-for="(props, i) in tableHeader" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope" class="index-parent">
                      <div class="index" v-if="props.type">
                        <img src='@/assets/images/home/icon-hg1.png' v-if='((page.current - 1) * page.size) + scope.$index + 1 == 1'/>
                        <img src='@/assets/images/home/icon-hg2.png' v-else-if='((page.current - 1) * page.size) + scope.$index + 1 == 2'/>
                        <img src='@/assets/images/home/icon-hg3.png' v-else-if='((page.current - 1) * page.size) + scope.$index + 1 == 3'/>
                        <img src='@/assets/images/home/icon-hg4.png' v-else-if='((page.current - 1) * page.size) + scope.$index + 1 == 4'/>
                        <img src='@/assets/images/home/icon-hg5.png' v-else-if='((page.current - 1) * page.size) + scope.$index + 1 == 5'/>
                        <i v-else></i>
                        <div>{{((page.current - 1) * page.size) + scope.$index + 1}}</div>
                      </div>
                      <div v-else>
                        <!-- 交易额需要转换 -->
                        <div v-if="props.prop === 'transaction' || props.prop === 'totalPrice' || props.prop === 'creditAmount'
                        || props.prop === 'loanAmount' || props.prop === 'loanBalance'
                        " class="text">
                         {{setTransaction( scope.row[props.prop]) | isEmptyVal }}
                        </div>
                        <div v-else class="text">{{ scope.row[props.prop] | isEmptyVal }}</div>
                      </div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <!-- 交易额没有分页 -->
            <div class='pages' >
              <span>共 {{ page.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                @current-change="currentChange"
              />
              <pagination @currentChange="currentChange" @sizeChange="sizeChange"/>
            </div>
          </div>
        </div>
        <div class='close' @click='close'>
          <img src='@/assets/images/home/close.png'/>
          <!-- <CircleClose style="width: 32px; height: 32px;color: #fff"/> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import common from '@/utils/common'
import tableheads from './tableheads.json'
import topBar from './compontents/topBar.vue'
import homeHead from './compontents/homeHead.vue'
import leftTop from './compontents/leftTop.vue'
import leftCenter from './compontents/leftCenter.vue'
import leftBottom from './compontents/leftBottom.vue'
import centerTop from './compontents/centerTop.vue'
import centerBottom from './compontents/centerBottom.vue'
import rightTop from './compontents/rightTop.vue'
import rightCenter from './compontents/rightCenter.vue'
import rightBottom from './compontents/rightBottom.vue'
import apiPath from '@config/api.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import { Loading } from 'element-ui'
const {mapState, mapMutations} = require('vuex')

export default {
  components: {
    topBar,
    homeHead,
    leftTop,
    leftCenter,
    leftBottom,
    centerTop,
    centerBottom,
    rightTop,
    rightCenter,
    rightBottom,
    pagination
  },

  data () {
    return {
      LANMSG: {},
      tableData: [],
      tableHeader: [],
      transform: 'scale(1,1)',
      top: 0,
      left: 0,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      title: '',
      headList: [],
      modelShow: false
    }
  },

  computed: {
    ...mapState({
      model: (state) => {
        return state.home.model
      },
      home: (state) => {
        return state.home
      }
    })
  },

  watch: {
    model: function (e) {
      if (e) {
        this.page = {
          current: 1,
          size: 10,
          total: 0
        }
        // 获取表头
        this.tableHeader = tableheads[this.home.modelUrl]
        // 根据来源获取列表
        this.getList()
      } else {
        this.page = {
          current: 1,
          size: 10,
          total: 0
        }
        this.tableHeader = []
        this.tableData = []
        this.title = ''
        this.headList = []
        this.modelShow = e
      }
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
  },

  mounted () {
    this.close()
    let width = 1920
    let height = 1080
    // let scalex = document.body.clientWidth / width
    // let scaley = document.body.clientHeight / height
    // this.transform = `scale(${scalex},${scale})`
    // this.left = `-${((1 - scalex) * width) / 2}px`
    // this.top = `-${((1 - scaley) * height) / 2}px`
    // window.onresize = (e) => {
    //   console.log(document.body.clientWidth, document.body.offsetWidth)
    //   let scalex = document.body.clientWidth / width
    //   // let scaley = document.body.clientHeight / height
    //   this.transform = `scale(${scalex},${scalex})`
    //   this.left = `-${((1 - scalex) * width) / 2}px`
    //   this.top = `-${((1 - scalex) * width) / 2}px`
    // }
    let scalex = document.body.clientWidth / width
    // let scaley = document.body.clientHeight / height
    this.transform = `scale(${scalex},${scalex})`
    this.left = `-${((1 - scalex) * width) / 2}px`
    this.top = `-${((1 - scalex) * height) / 2}px`
    window.onresize = (e) => {
      // console.log(document.body.clientWidth, document.body.offsetWidth)
      let scalex = document.body.clientWidth / width
      // let scaley = document.body.clientHeight / height
      this.transform = `scale(${scalex},${scalex})`
      this.left = `-${((1 - scalex) * width) / 2}px`
      this.top = `-${((1 - scalex) * height) / 2}px`
    }
  },

  methods: {
    ...mapMutations(['setModelInfo']),
    // 关闭弹框
    close () {
      this.setModelInfo({
        modelUrl: '',
        model: false
      })
    },
    setTransaction (val) {
      return (val / 10000).toFixed(2)
    },
    getList () {
      const loadTips = Loading.service()
      let setMethod = 'get'
      this.home.method && (setMethod = this.home.method)
      if (setMethod === 'post') {
        this.$ajax({
          method: setMethod,
          url: `${apiPath.bigData.home[this.home.modelUrl]}`,
          data: {
            pageNum: this.page.current,
            pageSize: this.page.size,
            sortParam: '',
            searchParam: '',
            companyType: this.home.modelUrl === 'getCrossBorderEnterprise' ? this.home.companyType : null
            // yearTime: this.home.homeTime
          }
        }).then(res => {
          loadTips.close()
          this.getListThen(res)
        }).catch(e => {
          loadTips.close()
          this.getListCatch()
        })
      } else {
        this.$ajax({
          method: setMethod,
          url: `${apiPath.bigData.home[this.home.modelUrl]}`,
          params: {
            pageIndex: this.page.current,
            pageSize: this.page.size,
            sortParam: '',
            searchParam: ''
            // yearTime: this.home.homeTime
          }
        }).then(res => {
          loadTips.close()
          this.getListThen(res)
        }).catch(e => {
          loadTips.close()
          this.getListCatch()
        })
      }
    },
    getListThen (res = {}) {
      let dataInfo = res.data || {}
      let list = []
      let total = 0
      if (dataInfo.list && dataInfo.list.records) {
        list = dataInfo.list.records || []
        total = dataInfo.list.total
      } else if (dataInfo.records) {
        list = dataInfo.records || []
        total = dataInfo.total
      } else {
        list = dataInfo
        total = res.total
      }
      this.title = this.home.title
      this.headList = this.home.headList
      this.tableData = list || []
      this.page.total = total
      this.modelShow = true
    },
    getListCatch (res = {}) {
      this.close()
      this.modelShow = false
    },
    currentChange (e) {
      this.page.current = e
      this.getList()
    },
    sizeChange (e) {
      this.page.current = 1
      this.page.size = e
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>

  .home{
    width: 1920px;
    height: 1080px;
    position: absolute;
    top:0;
    left:0;
    // background: url('~@/assets/images/home/bg.png') no-repeat 0 0;
    .home-main{
      height: calc(100% - 247px);
      margin: 0 30px 30px;
      display:flex;
      justify-content: space-between;
      .home-left{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
      }
      .home-center{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
      }
      .home-bottom{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
      }
    }
  }
</style>
<style lang='scss'>
  .el-dialog{
    min-width: 50%;
    // margin: 0 !important;
  }
  .commonDialog{
    // width: 1410px;
    width: 90% !important;
    // min-height: 770px !important;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
    margin-left: 0 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2018;
    position: absolute;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    .el-dialog__header{
      display: none;
      padding:0;
    }
    .el-dialog__body{
      position: relative;
      padding: 0;
      height: 100%;
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-radius: 0px;
      background: rgba(0, 0, 0, 0.5);
    }
    .ux-panel{
      position: relative;
      z-index: 1;
      padding-top: 70px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 1px solid #22bdfe;
      background: rgba(17, 47, 72, 0.9);
      .head-list{
        display: flex;
        margin-top: 32px;
        justify-content: space-between;
        padding: 0 150px;
        color:#fff;
        font-size:24px;
      }
      .title{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .title::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 30px * 2);
        height: 0;
        border: 1px solid;
        border-image: linear-gradient(63deg, rgba(71, 241, 255, 0), #38c2ff, rgba(34, 222, 254, 0)) 1 1;
      }
      .index-parent{
        position: relative;
      }
      .index{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        img {
          // position: absolute;
          // top: 0px;
          // left:56px;
          width: 20px;
          margin-right: 10px;
          height: 20px;
        }
        i{
          width: 20px;
          margin-right: 10px;
          height: 20px;
        }
      }
      .tabs{
        padding: 0 30px;
        box-sizing: border-box;
        .tabs-header{
          // margin-bottom:20px;
          text-align: center;
        }
        .tabs-header {
          .ux-dark-el-radio {
            .is-active,
            .is-focus {
              span {
                color: #ffffff;
                box-shadow: -1px 0 0 0 #1c8be2;
                border-color: #1c8be2;
                background-color: #1c8be2;
              }
            }
            span {
              padding: 9px 12px;
              font-size: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #2bb0f0;
              border-color: #2d6bab;
              background: rgba(24, 127, 215, 0.2);
            }
          }
          .el-radio-button__inner{
            margin: 0 4px;
            padding: 10px 12px;
            font-size: 18px;
            border-radius: 0px 0px 4px 4px;
            color: #2bb0f0;
            border: 1px solid #2d6bab;
            background: rgba(24, 127, 215, 0.2);
          }
          .el-radio-group{
            font-size: 0
          }
        }
        .tabs-pane {
          .el-tabs {
            .el-tabs__header {
              display: none;
            }
          }
          .ux-table-wrap {
          }
        }
        table {
          .cell {
            padding: 12px 10px;
          }
          .el-table__cell{
             border-right: 1px solid #2d6bab;
             border-bottom: 1px solid #2d6bab;
          }
          th .cell {
            text-align: center;
            font-size: 18px !important;
          }
        }
      }
      .close{
        position: absolute;
        right: 20px;
        top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: content-box;
        padding: 5px;
        width: 24px;
        height: 24px;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
    .ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 30px 0;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      // height: 550px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        margin-bottom: 10px;
        table {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }
  }
  .el-input-dark {
    .el-input__inner{
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      border: 1px solid #2d6bab;
      background: rgba(24, 127, 215, 0.2);
      padding: 0 15px !important;
    }
    .search {
        color: #ffffff;
        background: #1c8be2;
    }
    .el-input__wrapper{
      padding: 0 !important;
      margin-bottom:0 !important;
      box-shadow: none !important;
    }
    .el-input--suffix{
      margin-bottom:0 !important;
    }
    .el-input__suffix {
      right: 5px;
      transition: all .3s;
      position: absolute;
      top: 0;
      height: 100%;
      color: #C0C4CC;
      text-align: center;
    }
    .select-trigger{
      margin-bottom:0 !important;
    }
  }
  .el-btn-dark{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #2bb0f0;
    border: 1px solid #2d6bab;
    background: transparent;
    &:focus,
    &:hover {
      color: #2bb0f0;
      border-color: #2d6bab;
      background: transparent;
    }
  }
  .ux-dark-el-pagination {
    padding-right: 0;
    .btn-prev,
    .el-pager li,
    .el-pager li:last-child,
    .el-pager li.active,
    .btn-next {
      min-width: 28px !important;
      min-height: 28px !important;
      line-height: 26px !important;
      font-size: 16px !important;
      color: #ffffff !important;
      border: 1px solid #2d95ea;
      background-color: transparent !important;
    }
    .el-pager li.active {
      background: #1c8be2 !important;
    }
    .btn-next {
      margin-right: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/index.vue